export default function React_ES6_Modules() {
  return (
    <div>
      <h1>React_ES6_Modules Component</h1>
      <p>This is the React_ES6_Modules tutorial page.</p>
    </div>
  );
}
